import "./style.scss"
import '@fancyapps/fancybox'
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css'
$(function() {
    $(window).on('resize',function() {
        if ($(window).width() < 769) {
            $('#keyvisual .sect-l').css({
                'height': $(window).width() * 0.56
            })
        };
    }).trigger('resize');

    $('#keyvisual a').fancybox({

    });
})